<template>
  <div
    class="headerSecond"
    :class="
      scrolled
        ? 'hidden_menu'
        : {
            hide: Setting,
          }
    "
    :key="qqq"
  >
    <div class="container">
      <div class="headerSecond_wrap" v-if="userType === 'superadmin' || userRoleAbilities">
        <div ref="list" id="list" class="headerSecond_box">
          <template v-for="(button, key) in checkPageType">
            <v-btn
              v-if="checkShowButton(button)"
              :key="key"
              class="nav_btn"
              text
              :exact="button.exact ? button.exact : false"
              :to="{ name: button.toName, query: button.toQuery }"
              @click="qqq++"
            >
              <BaseIcon :icon="button.icon" />
              {{ button.text }}
            </v-btn>
          </template>
        </div>
        <div id="headerSecond-toggler" class="dropdown">
          <button class="dropdown-btn">
            <MenuMoreIcon />
          </button>
          <div class="dropdown-content" id="headerSecond-list"></div>
        </div>
      </div>
      <div class="headerSecond_wrap" v-else>
        <template v-for="(button, key) in checkPageType">
          <v-skeleton-loader
            v-if="button.show ? button.show : false"
            :key="key"
            class="skeleton_btn"
            tile
            type="button"
          ></v-skeleton-loader>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import MenuMoreIcon from 'components/icons/MenuMore'
import { mapGetters } from 'vuex'
import pages_config from '~/configs/pages'
export default {
  name: 'HeaderSecond',
  components: {
    MenuMoreIcon,
  },
  props: ['type'],
  data: () => ({
    invisibleElements: null,
    toQuery: { page: 1, limit: 10 },
    scrolled: false,
    qqq: 456,
  }),
  computed: {
    ...mapGetters('user', ['userRoleAbilities', 'userType']),
    Setting() {
      return this.$route.name === 'Setting'
    },
    windowWidth() {
      return this.$vuetify.breakpoint.width
    },
    checkPageType() {
      if (this.type) {
        const pages = pages_config({})[this.type].pages.flat()
        return this.type === 'setting'
          ? [
              {
                toName: 'Setting',
                text: this.localStorage.translations.pages.setting.pages['vse-nastroyki'],
                icon: 'pages-settings',
                exact: true,
              },
              ...pages,
            ]
          : pages
      } else return null
    },
  },
  created() {
    window.addEventListener('resize', () => {
      setTimeout(this.restart(), 250)
    })
  },
  destroyed() {
    window.addEventListener('resize', () => {
      setTimeout(this.restart(), 250)
    })
  },
  updated() {
    setTimeout(this.restart(), 250)
  },

  mounted() {
    setTimeout(this.restart(), 250)
  },
  methods: {
    checkShowButton(item) {
      return (
        (item.access !== undefined ? item.access : true) &&
        (item.hidden !== undefined ? this.$vuetify.breakpoint.width > item.hidden : true)
      )
    },
    getInvisible(listElements) {
      let list = document.getElementById('list')
      let invisible = listElements.filter((item) => {
        if (
          item.getBoundingClientRect().left + item.getBoundingClientRect().width >
          list.clientWidth + 30
        ) {
          return item
        }
      })
      return invisible
    },
    moveForward() {
      let button = document.getElementById('headerSecond-toggler')
      let listElements = Array.from(document.querySelectorAll('#list .nav_btn'))
      let invisibleElements = this.getInvisible(listElements)
      this.invisibleElements = invisibleElements
      let menuList = document.getElementById('headerSecond-list')
      if (menuList) {
        invisibleElements.forEach((item) => {
          menuList.appendChild(item)
        })
      }
      if (button !== null) {
        if (invisibleElements.length) {
          button.style.visibility = 'visible'
        } else {
          button.style.visibility = 'hidden'
        }
      }
    },
    moveBackward() {
      let menuListElements = Array.from(document.querySelectorAll('#headerSecond-list .nav_btn')),
        list = document.getElementById('list')

      menuListElements.forEach((item) => {
        list.appendChild(item)
      })
    },
    restart() {
      this.moveBackward()
      this.moveForward()
    },
  },
}
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}

.fixed {
  position: fixed;
  width: 100%;
  background-color: #f2f2f2;
}

.hidden_menu {
  @extend .hidden;
}

.headerSecond {
  //z-index: 7;
  .skeleton_btn {
    position: relative;
    padding: 17px 24px !important;
    &:not(:first-of-type) {
      &::before {
        content: '' !important;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 30px;
        background: #bec9cf;
        opacity: 1 !important;
      }
    }
    &:first-of-type {
      padding: 17px 24px 17px 0 !important;
    }
    .v-skeleton-loader__button {
      width: 50px;
    }
  }
  .container {
    background: #ffffff;
  }
  &_wrap {
    transition: 0.7s;
    display: flex;
    justify-content: space-between;
  }

  &.hide {
    margin-top: 0;
  }
  &_box {
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    width: calc(100% - 60px);
    transition: 0.3s;
    :deep(.v-btn) {
      position: relative;
      text-transform: none;
      color: #828282;
      padding: 15px 25px 16px !important;
      height: 50px !important;
      font-weight: 400;
      font-size: 17px;
      line-height: 20px;
      // min-width: auto;
      border-radius: 0 !important;
      transition: 0.3s;
      svg {
        transition: 0.3s;
        margin-right: 10px;
        max-height: 19px;
        width: 19px;
        height: auto;
        path {
          fill: #828282 !important;
        }
      }

      &:hover {
        color: #277faf;
        svg {
          path {
            fill: #277faf !important;
          }
        }
      }
      &::after {
        content: '';
        width: 50%;
        max-width: 69px;
        height: 3px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0px;
        transition: 0.3s;
      }
      &:first-of-type {
        padding: 15px 25px 16px 0 !important;
        &::after {
          transform: translateX(-65%);
        }
      }

      &.v-btn--active {
        color: #277faf;
        // border-bottom: 1px solid #2c2c2c;
        border-radius: 0px;
        // &:first-of-type {
        //     color: #277faf;
        //     border-bottom: none;
        //     &:hover {
        //         color: #16558f;
        //         &::after {
        //             background: #16558f;
        //         }
        //     }
        //     &::after {
        //         background: transparent;
        //     }
        // }
        &::after {
          background: #277faf;
        }
        svg {
          path {
            fill: #277faf !important;
          }
        }
      }
    }
  }

  .dropdown {
    position: relative;
    display: inline-block;
    &-btn:deep() {
      display: flex;
      align-items: center;
      padding: 0px 22px;
      height: 100%;
      transition: 0.3s;
      svg {
        path {
          fill: #277faf;
        }
      }
    }
    &-content {
      visibility: hidden;
      position: absolute;
      //background-color: #ffffff;
      min-width: max-content;
      z-index: 3;
      right: 0;
      transition: 0.3s;
      opacity: 0;
      background: #f2f2f2;
      box-shadow: 0px 20px 22px rgba(145, 145, 145, 0.25);
      border-radius: 0px 0px 10px 10px;
    }
    :deep().v-btn {
      display: block;
      font-weight: 400;
      font-size: 1.063rem;
      padding: 10px 20px !important;
      color: #333333 !important;
      text-align: start;
      text-transform: none;
      border-radius: 0 !important;
      &__content {
        justify-content: flex-start !important;
        svg {
          max-height: 18px;
          margin-right: 10px;
          path {
            fill: #333333 !important;
          }
        }
      }

      &:first-of-type {
        padding: 10px 20px !important;
      }
      &::before {
        content: none !important;
      }
      &:hover {
        background: #277faf;
        color: #ffffff !important;
        svg {
          path {
            fill: #ffffff !important;
          }
        }
      }
      &.v-btn--active {
        color: #ffffff !important;
        background: #277faf;
        // &:hover {
        //     background: #16558f;
        // }
        svg {
          path {
            fill: #ffffff !important;
          }
        }
      }
      &:last-of-type {
        border-radius: 0px 0px 10px 10px !important;
      }
    }
    &:hover {
      .dropdown-btn:deep() {
        background: #f2f2f2;
      }
      .dropdown-content {
        visibility: visible;
        opacity: 1;
      }
    }
  }
}
</style>
